import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { BrowserDocumentService } from 'pf-frontend-common/src/service/browser-document/service';
import { WindowService } from 'pf-frontend-common/src/service/window/service';

import { GoogleRecaptchaScript } from './script';

export function GoogleRecaptchaScriptFactory(): GoogleRecaptchaScript {
  return new GoogleRecaptchaScript(EventEmitterFactory(), BrowserDocumentService(), WindowService());
}
